module.exports = __webpack_public_path__ + "img/image-16.8d75a5e0.jpg";